export default __webpack_public_path__ + "static/media/wireframing.06ec5d75.svg";